import { render, staticRenderFns } from "./saas_apply_list.vue?vue&type=template&id=49b62788&scoped=true"
import script from "./saas_apply_list.vue?vue&type=script&lang=js"
export * from "./saas_apply_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b62788",
  null
  
)

export default component.exports